import {PropertyFilterProps} from "@amzn/awsui-components-react-v3";
import {
    END_TIME_MAX,
    FilterOperation,
    QueryVerb, START_TIME_MIN,
    filterPropertyConfigMap, FilterTokenOperators, FilterPropertyGroups
} from "src/components/sm-overview-dashboards/workflow-list-view/filters/filter-constants";
import {PropertyFilterToken} from "@amzn/awsui-collection-hooks/dist/cjs/interfaces";

export const convertFilterTokensToUrlQuery = (filterTokens: PropertyFilterProps.Query) => {
    return filterTokens.tokens.reduce((filterQuery, token) => {
        if(filterPropertyConfigMap[token.propertyKey|| ''].group === FilterPropertyGroups.TIME_FILTERS){
           const epochTime = Date.parse(token.value);
           const timeRangeString =  filterQuery[`${QueryVerb.MUST}::${FilterOperation.RANGE}:${token.propertyKey}`] || '';
           const [startTime, endTime] = timeRangeString.split(':');
           let timeRange
           if(token.operator === FilterTokenOperators.GREATER_THAN_EQUAL){
               timeRange = `${epochTime}:${endTime || END_TIME_MAX}`;
           }
           if(token.operator === FilterTokenOperators.LESS_THAN_EQUAL){
               timeRange = `${startTime || START_TIME_MIN}:${epochTime}`;
           }
            filterQuery[`${QueryVerb.MUST}::${FilterOperation.RANGE}:${token.propertyKey}`] = timeRange || '';
           return filterQuery
        } else if (filterPropertyConfigMap[token.propertyKey|| ''].group === FilterPropertyGroups.MULTI_SELECT_FILTERS) {
            if(token.operator === FilterTokenOperators.NOT_EQUAL){
                filterQuery[`${QueryVerb.MUST_NOT}::${FilterOperation.MATCH_ANY}:${token.propertyKey}`] = token.value;
            }else{
                filterQuery[`${QueryVerb.MUST}::${FilterOperation.MATCH_ANY}:${token.propertyKey}`] = token.value;
            }
            return filterQuery;
        }

        switch (token.operator) {
            case FilterTokenOperators.EQUAL:
                filterQuery[`${QueryVerb.MUST}::${FilterOperation.MATCH}:${token.propertyKey}`] = token.value;
                return filterQuery;
            case FilterTokenOperators.NOT_EQUAL:
                filterQuery[`${QueryVerb.MUST_NOT}::${FilterOperation.MATCH}:${token.propertyKey}`] = token.value;
                return filterQuery;
            case FilterTokenOperators.REGEX:
                filterQuery[`${QueryVerb.MUST}::${FilterOperation.REGEX}:${token.propertyKey}`] = token.value;
                return filterQuery;
        }

        return filterQuery
    }, {} as Record<string, string>);
}

export const convertFilterUrlQueryToFilterTokens = (filterUrRlQuery: Record<string, string>) => {
    return Object.keys(filterUrRlQuery).reduce((filterTokens: PropertyFilterToken[], filter: string) => {
        const [queryVerb, filterOpsData] = filter.split('::');
        const [filterOp, property] = filterOpsData.split(':');
        if(queryVerb === QueryVerb.MUST_NOT) {
            filterTokens.push({
                operator: FilterTokenOperators.NOT_EQUAL,
                propertyKey: property,
                value: filterUrRlQuery[filter]
            })
        }else {
            switch (filterOp) {
                case FilterOperation.MATCH:
                    filterTokens.push({
                        operator: FilterTokenOperators.EQUAL,
                        propertyKey: property,
                        value: filterUrRlQuery[filter]
                    });
                    break;
                case FilterOperation.REGEX:
                    filterTokens.push({
                        operator: FilterTokenOperators.REGEX,
                        propertyKey: property,
                        value: filterUrRlQuery[filter]
                    });
                    break;
                case FilterOperation.MATCH_ANY:
                    filterTokens.push({
                        operator: FilterTokenOperators.EQUAL,
                        propertyKey: property,
                        value: filterUrRlQuery[filter]
                    });
                    break;
                case FilterOperation.RANGE:
                    const [rangeStart, rangeEnd] = filterUrRlQuery[filter].split(':');
                    const rangeStartDate = new Date(parseInt(rangeStart));
                    const rangeEndDate = new Date(parseInt(rangeEnd));
                    filterTokens.push({
                        operator: FilterTokenOperators.GREATER_THAN_EQUAL,
                        propertyKey: property,
                        value: `${rangeStartDate.getFullYear()}-${rangeStartDate.getMonth() + 1}-${rangeStartDate.getDate()}`
                    })
                    filterTokens.push({
                        operator: FilterTokenOperators.LESS_THAN_EQUAL,
                        propertyKey: property,
                        value:  `${rangeEndDate.getFullYear()}-${rangeEndDate.getMonth() + 1}-${rangeEndDate.getDate()}`
                    })
                    break;
            }
        }
        return [...filterTokens];
    }, [])
}
